import React from "react";
import Container from "../../Components/Container";
import AkoTable from "../../Components/Table";
import { Download } from "../../Utils/icons";
import { useOrders } from "./Hooks";
import Loading from "../../Components/Loading";

const Orders = () => {
  const { state, loading } = useOrders();
  if (loading) {
    return <Loading height={"400"} />;
  }
  return (
    <Container
      render={() => {
        return (
          <div className="mb-15">
            <p className="fs-11 fw-600 lh-25  text-main">
              فاکتور‌های شارژ پنل پیامک روز کاری بعد از پرداخت داخل این سامانه
              قابل مشاهده و دریافت می‌باشند.
            </p>
            <p className="fs-11 fw-600 lh-25  text-main">
              {" "}
              جهت دریافت هر فاکتور بر روی آیکن
              <span style={{ margin: "0 5px", verticalAlign: "-5px" }}>
                <Download />
              </span>
              رو به روی هر سطر از فاکتور‌های ایجاد شده کلیک کنید.{" "}
            </p>
          </div>
        );
      }}
    >
      <AkoTable
        paginate={state}
        data={state.data}
        subtitle="فاکتور‌های قبل از سال ۱۴۰۲ از طریق این سامانه قابل دریافت نمی‌باشند، برای دریافت با پشتیبانی در تماس باشید."
      />
    </Container>
  );
};

export default Orders;
